import { put, takeLatest, all, select } from 'redux-saga/effects';
import { API_URL } from 'containers/App/constants';
import {
  GET_BRANDS,
  BRAND_SELECTED,
  MODEL_SELECTED,
  VERSION_SELECTED,
  CAR_RECEIVED,
} from './constants';

import {
  brandsLoaded,
  modelsLoaded,
  versionsLoaded,
  carLoaded,
  carImagesLoaded,
} from './actions';
import {
  makeSelectSelectedBrand,
  makeSelectSelectedModel,
  makeSelectSelectedModelName,
  makeSelectSelectedVersion,
  makeSelectCarCode,
  makeSelectSelectedModelYear
} from './selectors';

import { getRequestHeadersAsLogged, responseHandler } from '../../utils/auth';

function* fetchBrands() {
  const requestURL = `${API_URL}car/brands`;

  try {
    const parameters = {
      method: 'GET',
      headers: getRequestHeadersAsLogged(),
    };

    const request = yield fetch(requestURL, parameters).then(response =>
      responseHandler(response)
    );

    yield put(brandsLoaded(request.data));
  } catch (err) {
    // yield put(brandsError(err));
    console.log('request error', err);
  }
}

function* fetchModels() {
  const brand = yield select(makeSelectSelectedBrand());
  const requestURL = `${API_URL}car/models?brand=${brand}`;

  try {
    const parameters = {
      method: 'GET',
      headers: getRequestHeadersAsLogged(),
    };

    const request = yield fetch(requestURL, parameters).then(response =>
      responseHandler(response)
    );
    yield put(modelsLoaded(request.data));
  } catch (err) {
    // yield put(brandsError(err));
    console.log('request error', err);
  }
}

function* fetchVersions() {
  const model = yield select(makeSelectSelectedModel());
  const modelName = yield select(makeSelectSelectedModelName());
  const modelYear = yield select(makeSelectSelectedModelYear());
  const requestURL = `${API_URL}car/versions/${model}/${modelYear}`;

  try {
    const parameters = {
      method: 'GET',
      headers: getRequestHeadersAsLogged(),
    };

    const request = yield fetch(requestURL, parameters).then(response =>
      responseHandler(response)
    );

    const options = request.data;
    options.map(item => (item.name = item.name.replace(modelName, '')));
    yield put(versionsLoaded(options));
  } catch (err) {
    // yield put(brandsError(err));
    console.log('request error', err);
  }
}

function* fetchCar() {
  const selected = yield select(makeSelectSelectedVersion());

  if (selected) {
    const [codiceMotornet, codiceEurotax] = selected.split('-');
    const requestURL = `${API_URL}car?motornet=${codiceMotornet}&eurotax=${codiceEurotax}`;
    try {
      const parameters = {
        method: 'GET',
        headers: getRequestHeadersAsLogged(),
      };
      const request = yield fetch(requestURL, parameters).then(response =>
        responseHandler(response)
      );
      yield put(carLoaded(request.data));
    } catch (err) {
      // yield put(carError(err));
      console.log('request error', err);
    }
  }
}

function* fetchImages() {
  const carId = yield select(makeSelectCarCode());
  const requestURL = `${API_URL}car/images/${carId}`;
  try {
    const parameters = {
      method: 'GET',
      headers: getRequestHeadersAsLogged(),
    };
    const request = yield fetch(requestURL, parameters).then(response =>
      responseHandler(response)
    );
    yield put(carImagesLoaded({default: request.data}));
  } catch (err) {
    // yield put(carError(err));
    console.log('request error', err);
  }
}

function* actionWatcher() {
  yield takeLatest(GET_BRANDS, fetchBrands);
  yield takeLatest(BRAND_SELECTED, fetchModels);
  yield takeLatest(MODEL_SELECTED, fetchVersions);
  yield takeLatest(VERSION_SELECTED, fetchCar);
  yield takeLatest(CAR_RECEIVED, fetchImages);
}

export default function* carsData() {
  yield all([actionWatcher()]);
}
